import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAgent } from "../../api/apiAgents";
import parseError from "../../utils/parseError";

const useDeleteAgent = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAgentAction, isPending } = useMutation({
        mutationFn: deleteAgent,
        onSuccess: (res) => {
            const message = res?.message || "Agent archived successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["agents"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to archive agent");
        },
    });

    return { deleteAgent: deleteAgentAction, isPending };
};

export default useDeleteAgent;
